import { render } from "./FooterMock.vue?vue&type=template&id=34a38b55&scoped=true"
import script from "./FooterMock.vue?vue&type=script&lang=js"
export * from "./FooterMock.vue?vue&type=script&lang=js"

import "./FooterMock.vue?vue&type=style&index=0&id=34a38b55&lang=scss&scoped=true"
import "./FooterMock.vue?vue&type=style&index=1&id=34a38b55&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a38b55"]])

export default __exports__